import * as React from "react";
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import FindPharmacy from './findPharmacy/findPharmacy';
import { formatPhoneNumber } from "../../helpers/formatting";
import { getDirectionsUrl } from "../../helpers/location";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";

export default class PharmacyInfo extends React.Component {
    constructor(props) {
        super(props);
        this.toggleFindPharmacy = this.toggleFindPharmacy.bind(this);
        this.redirectToMap = this.redirectToMap.bind(this);
        this.state = { showFindPharmacy: false };
    }

    componentWillMount() {
        const pharmacy = this.props.pharmacy;
        if (pharmacy) {
            const address = pharmacy.Address;
            const toAddress = address.StreetAddress + ', ' + address.City + ', ' + address.State + ' ' + address.Zip;
            this.setState({ directionsUrl: getDirectionsUrl(null, toAddress) });
        }
    }

    componentDidMount() {
        logUI("MBHWeb.UI.Rx.PharmacyInfo.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    toggleFindPharmacy() {
        if (this.state.showFindPharmacy) {
            this.closeFindPharmacy();
        }
        else {
            this.openFindPharmacy();
        }
    }

    openFindPharmacy() {
        this.setState({ showFindPharmacy: true });
    }

    closeFindPharmacy(pharmacy) {
        if (pharmacy && this.props.onChange) {
            this.props.onChange(pharmacy);
        }
        this.setState({ showFindPharmacy: false });
    }

    redirectToMap() {
        if (this.state.directionsUrl) {
            window.open(this.state.directionsUrl, "_blank");
        }
    }

    render() {
        const { pharmacy } = this.props;
        const address = pharmacy.Address;
        const phoneNumber = pharmacy && formatPhoneNumber(pharmacy.PhoneNumber);
        const IsPharmacyClosed = pharmacy && typeof pharmacy.IsPharmacyActive !== 'undefined' && pharmacy.IsPharmacyActive === false ? true : false;
        const hoursTodayText = pharmacy && pharmacy.OperationHours && pharmacy.OperationHours.Display && pharmacy.OperationHours.Display.HoursOfOperationToday && pharmacy.OperationHours.Display.HoursOfOperationToday.toUpperCase() === "PERMANENTLY CLOSED" ? null : <span className="today-text">Hours Today: </span>;
        return (
            <div className="row your-pharmacy-container">

                <div className="col-12">
                    <div className="row">
                        <div className="col-12 your-pharmacy__name">
                            <div className="pharmacy-name">{pharmacy.Name} <a href="#" onClick={e => { this.openFindPharmacy(); e.preventDefault(); }}>Edit</a></div>
                            {this.state.showFindPharmacy &&
                                <Modal isOpen={this.state.showFindPharmacy} toggle={this.toggleFindPharmacy} centered>
                                    <ModalHeader toggle={this.toggleFindPharmacy}>Edit Your Pharmacy</ModalHeader>
                                <ModalBody><FindPharmacy showAsModal onClose={pharmacy => this.closeFindPharmacy(pharmacy)} /></ModalBody>
                                </Modal>
                            }
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 col-sm-6 col-md-7 your-pharmacy__address">
                            <div className="pharmacy-address">
                                <a className="directions-link" onClick={() => this.redirectToMap()}>
                                    <div className="details-icon-prepend">
                                        <div className="icon-col">
                                            <span className="icon-address" />
                                        </div>
                                        <div className="details-col">
                                            <div className="home-street-address">
                                                {address.StreetAddress.split(',')[0]}
                                                {address.StreetAddress.split(',')[1] && <span>, {address.StreetAddress.split(',')[1]}</span>}
                                            </div>
                                            <div>{address.City}, {address.State} {address.Zip.split('-')[0]}</div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-12 col-sm-6 col-md-5 your-pharmacy__phone-hours">
                            <div className="pharmacy-phone">
                                <a className="phone-link" href={"tel:" + phoneNumber}>
                                    <div className="details-icon-prepend">
                                        <div className="icon-col">
                                            <span className="icon-phone" />
                                        </div>
                                        <div className="details-col">
                                            {phoneNumber}
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className="pharmacy-hours" ng-if="$ctrl.defaultPharmacy.OperationHours.Display.HoursOfOperationToday">
                                <div className="details-icon-prepend">
                                    <div className="icon-col">
                                        <span className="icon-clock" />
                                    </div>
                                    <div className="details-col">
                                        {IsPharmacyClosed ? "PERMANENTLY CLOSED" : <>{hoursTodayText}{pharmacy.OperationHours.Display.HoursOfOperationToday}</> }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}